const { debounce, getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved && !this.hasAttribute('data-moved')) {
      window.setTimeout(() => {
        const moveToElement = this.moveToElement

        this.removeAttribute('data-module-drawers-move-me')

        moveToElement.appendChild(this)
      }, parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0)
    }

    if (this.shouldOpenOnLoad) {
      // Wait half a second as some drawers need to do some initialisation
      window.setTimeout(() => {
        this.elements.trigger.dispatchEvent(
          new Event('click', {
            bubbles: true,
          }),
        )
      }, 500)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onResize = this.onResize.bind(this)
    if (this.key === 'menu') {
      this.listeners.add(window, 'resize', debounce(this.onResize, 200))
    }
  }

  onResize () {
    if (
      window.drawers.activeDrawerKey === 'menu' &&
      window.BAO.MediaBreakpoints.isLg
    ) {
      window.drawers.activeDrawerKey = ''
    }
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
      accordionGroups: getElement('accordion-group', { context: this }),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)
    this.elements.accordionGroups?.els?.item?.elements?.forEach(element => {
      element.ariaExpanded = element.dataset.openByDefault === 'true'
    })
    this.elements.accordionGroups?.els?.trigger?.elements?.forEach(element => {
      element.ariaExpanded = element.dataset.openByDefault === 'true'
    })
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }

  get shouldOpenOnLoad () {
    return this.dataset.openOnLoad === 'true'
  }
}

customElements.define('site-drawer', SiteDrawer)
